import moment from 'moment';

import { CodeTypeModel } from '../../app-lite/core/models/code-type';
import { JsonService }   from '../../app-lite/core/services/json.service';

export class BookingDiaryEventCtrl implements ng.IComponentController {
  event      : any;
  jobStatuses: Array<CodeTypeModel>;

  timeFormat = 'h:mm A';

  constructor (
    private $rootScope: ng.IRootScopeService,
    private jsonApi   : JsonService
  ) {}

  $onDestroy () {
    this.$rootScope.$broadcast('pg-tooltip-hide');
  }

  formatTime ( time : string ) : string {
    return moment(time).format(this.timeFormat);
  }

  getDescription ( decode = false ) : string {
    const description = ( this.event.description && decode )
      ? this.event.description.replace(/&#34;/g, '"')
      : this.event.description;

    const itemDescription = ( this.event.item_description && decode )
      ? this.event.item_description.replace(/&#34;/g, '"')
      : this.event.item_description;

    if (description && itemDescription) {
      return `${ description } - ${ itemDescription }`;
    }

    if (description) {
      return description;
    }

    if (itemDescription) {
      return itemDescription;
    }
  }

  getVehicleDescription () : string {
    return this.jsonApi.stripEmpties([
      this.event.vehicle_color,
      this.event.make,
      this.event.model,
      this.event.plate_number
    ], ' ') as string;
  }
}
